// extracted by mini-css-extract-plugin
export default {"ProductCallouts__container":"ProductCallouts-styles__ProductCallouts__container__HV6lC"};